export default function () {
  const preloaderEl = document.querySelector('.c-preloader');

  if (preloaderEl) {
    preloaderEl.addEventListener('transitionend', () => {
      preloaderEl.remove();
    }, { once: true });

    window.addEventListener('load', () => {
      preloaderEl.style.opacity = 0;
      preloaderEl.style.transform = 'translateY(-100%)';
      document.dispatchEvent(new CustomEvent('preloader:done', { bubbles: true }));
    });

    setTimeout(() => {
      const preloader = document.querySelector('.c-preloader');

      // check maybe preloader done before timeout
      if (preloader) {
        preloader.style.opacity = 0;
        preloaderEl.style.transform = 'translateY(-100%)';
        document.dispatchEvent(new CustomEvent('preloader:done', { bubbles: true }));
      }
    }, 7000);
  }
}
